module.exports = __webpack_public_path__ + "img/jpeg.4d931864.svg";